import { api } from './client';
import type { WorkspaceSettings } from '@/types/api';

export const workspaceSettingsApi = {
  get: async () => (await api.get<WorkspaceSettings>('/me/settings/workspace')).data,
  setRapidApiKey: async (key: string) => {
    await api.put('/me/settings/api-key', { key });
  },
  removeRapidApiKey: async () => {
    await api.delete('/me/settings/api-key');
  },
};
